import { z } from 'zod'
import i18n from '@/lib/i18n'

export const ddsSchema = z
	.object({
		subject: z.string().min(1, i18n.t('form.dds.subjectError')),
		type: z.string().min(1, i18n.t('form.dds.typeError')),
		description: z.string().min(10, i18n.t('form.dds.descriptionError')),
		attendeeIds: z.array(z.string()),
		// Tempo em que o DDS fica aberto para receber participantes
		durationMinutes: z
			.number()
			.int()
			.min(15, i18n.t('form.dds.durationError'))
			.max(120, i18n.t('form.dds.durationError')),
		// Presença por QR: dispensa participantes na criação
		attendanceEnabled: z.boolean(),
		image: z.any().optional(),
	})
	.refine((data) => data.attendanceEnabled || data.attendeeIds.length > 0, {
		message: i18n.t('form.dds.participantsError'),
		path: ['attendeeIds'],
	})

// input (o que o form manda para o resolver)
export type DdsInput = z.input<typeof ddsSchema>

// output (já coercido/validado; com Date)
export type DdsFormData = z.output<typeof ddsSchema>
